import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react'
import { motion } from 'framer-motion'
import ScrollArrow from './ScrollArrow'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface TeamProps {
  onApplyClick: () => void
}

const Team: React.FC<TeamProps> = ({ onApplyClick: _onApplyClick }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const panelsRef = useRef<HTMLDivElement>(null)
  const cardsRef = useRef<(HTMLDivElement | null)[]>([])
  const [currentScrollLeft, setCurrentScrollLeft] = useState(0)
  const [hoveredCard, setHoveredCard] = useState<number | null>(null)
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0, showAbove: true })
  const [isInView, setIsInView] = useState(false)
  const [hasNavigated, setHasNavigated] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  // Фиксированные данные для летающих иконок (оптимизировано)
  const flyingIcons = useMemo(() => {
    const icons = ['⚖️', '🔫', '🔗', '🌿', '🚔', '👮', '🏛️', '🧨', '🪴', '🚨','🚑','🛡️', '🔍','🪖','💵']
    return Array.from({ length: 16 }, (_, index) => ({
      id: index,
      left: (index % 4) * 25 + (index % 3) * 5,
      top: Math.floor(index / 4) * 25 + (index % 2) * 10,
      fontSize: 1.8 + (index % 3) * 0.3,
      icon: icons[index % icons.length],
      duration: 15 + (index % 5) * 3,
      delay: (index % 4) * 0.5,
      xOffset: (index % 3 - 1) * 20
    }))
  }, [])

  // Данные ответов для каждого участника команды (мемоизировано)
  const teamAnswers = useMemo(() => ({
    1: { // Richard Hugo
      answer1: "Мама просила держаться подальше от плохой компании. Я решил ее основать.",
      answer2: "Делаю так, чтобы всё шло по плану. Даже если плана не было.",
      answer3: "HUGO -  это когда амбиции не мешают человечности, а превосходство - это просто базовый минимум."
    },
    2: { // Lanirr Hugo
      answer1: "30.04.24 во время дальнобоя меня похитили и в поклоне я наблевал Richard'y на белые кроссовки, в ответ он принял меня в семью.",
      answer2: "Стараюсь сплотить коллектив общением и общим контентом. Стараюсь найти достойных кандидатов на Хай состав в гос фракции.",
      answer3: "Адекватность, лояльность, стремление двигаться только к вершинам. Hugo отличается в отношении к людям, стараться тщательно набирать людей с общими интересами, предложениями как улучшить жизнь в семье, обеспечивает комфортное погружение в наш коллектив."
    },
    3: { // Leeshawn Hugo
      answer1: "На август 25-го года я уже около полугода являюсь частью семьи HUGO. Мой путь сюда начался с Дня блата в шерифке при Dexter Hugo, после чего пройдя собеседование, Federick Hugo пригласил меня в ряды семьи.", 
      answer2: "Мой вклад — укрепление позиций HUGO в силовых структурах, чтобы каждый знал, кто такие HUGO, а также создание совместного контента с участниками семьи.",
      answer3: "HUGO — это семья, которая всегда движется только вперёд. Мы не стоим на месте и не сдаёмся перед трудностями — напротив, именно они делают нас сильнее и помогают прогрессировать."
    },
    4: { // Aleister Hugo
      answer1: "Первый раз вступил в семью 29.08.24 и по некоторым причинам покинул проект, но семью я не забыл. 30.06.25 я вернулся на проект и сразу же решил вступить в HUGO, о чем ни разу не пожалел.",
      answer2: "После возвращения я достаточно быстро поднялся по рангам до High Staff и начал всем помогать и решать проблемы. Это было замечено - теперь я занимаюсь помощью новичкам и контрактами семьи.",
      answer3: "HUGO - это стабильность, адекватность и стремление вперед!"
    },
    5: { // Tony Hugo
      answer1: "На июль 2025 года я состою в семье уже около 1 года и 3 месяцев.Пришёл на проект с двумя друзьями — начали развиваться, и вскоре решили вступить в фаму. Долго не раздумывая, решили, что пойдём именно в государственную семью.Примерно через полчаса после этого, будучи на первом уровне рыбалки, мы спросили в общем чате, набирает ли кто-нибудь в семью, и написали, что хотим в госку.К нам подошёл Коля (Dristerio) и выдал инвайт.",
      answer2: "Периодически накидываю идеи по улучшению различных процессов. В основном занимаюсь набором и обзвонами: помогаю новичкам адаптироваться, подсказываю, объясняю, если что-то непонятно. Также обучаю уже состоящих в семье ребят, как проводить обзвоны.Мой основной вклад - в подбор и развитие людей в семье.",
      answer3: "Hugo - это не просто фамилия на Majestic, это объединение адекватных, дружелюбных и готовых прийти на помощь людей. Hugo - это больше, чем просто фама. ЯМы - Hugo."
    },
    6: { // Logan Hugo
      answer1: "С самого начала. Я стоял у истоков HUGO, когда всё только зарождалось. Был не просто рядом — был внутри идеи.",
      answer2: "Я — как тень, что незаметно сопровождает свет. Появляюсь редко, но метко. Поддерживаю тех, кто продолжает развивать то, что мы начали.",
      answer3: "HUGO — это не просто тэг. Это атмосфера, где каждый не просто участник, а часть живого организма. У нас есть амбиции, но без гонки за статусом. В приоритете — уважение, стиль и общее движение вперёд."
    },
    7: { // Quincy Hugo
      answer1: "Третий человек в фаме,помогал основать, вложил душу.",
      answer2: "Для семьи я делаю контент, если вы еще не видели наш дискорд, то это делал я и сайт делал я, да короче все что нарисовано в HUGO - это я.",
      answer3: "HUGO не боится пробовать новое, всегда стоят за своих до талого, гребут бабосы лопатами и делают контент."
    },
          8: { // Federick Hugo
        answer1: "Присоединился к семье 1.3 года назад. Был впечатлен их подходом к развитию и возможностями для карьерного роста.",
        answer2: "Мой вклад - это развитие новых территорий и расширение влияния семьи. Открываю новые возможности для HUGO.",
        answer3: "Особенность HUGO в том, что мы не останавливаемся на достигнутом. Постоянно развиваемся и расширяем горизонты."
      }
    }), [])

  // Создаем 8 карт (мемоизировано)
  const cards = useMemo(() => Array.from({ length: 7 }, (_, index) => ({
    id: index + 1,
    title: `Команда ${index + 1}`,
    subtitle: `Позиция ${index + 1}`,
  })), [])

  // Создаем бесконечную карусель с минимальными дубликатами (мемоизировано)
  const infiniteCards = useMemo(() => [...cards, ...cards, ...cards], [cards]) // 3 набора = 24 карточки

  // Оптимизированная функция центрирования
  const centerFirstCard = useCallback(() => {
    if (!panelsRef.current || !containerRef.current) return
    
    // Не центрируем если пользователь уже навигаровал или если уже есть scrollLeft
    if (hasNavigated || panelsRef.current.scrollLeft > 0) return
    
    const containerWidth = containerRef.current.clientWidth || 0
    const cardWidth = 499
    const gap = 16
    
    const startIndex = 8
    const centerOffset = (startIndex * (cardWidth + gap)) - (containerWidth - cardWidth) / 2 + 15 // Небольшая корректировка влево
    
    // Мгновенное позиционирование без GSAP
    panelsRef.current.scrollLeft = centerOffset
    
    // Обновляем состояние currentScrollLeft
    setCurrentScrollLeft(centerOffset)
  }, [hasNavigated])

  // Логика бесконечного скролла без анимации
  const handleScroll = useCallback(() => {
    if (!panelsRef.current) return
    
    const scrollLeft = panelsRef.current.scrollLeft
    setCurrentScrollLeft(scrollLeft)
    
    const cardWidth = 499
    const gap = 16
    const totalCardWidth = cardWidth + gap
    const singleSetWidth = cards.length * totalCardWidth
    
    // Мгновенная логика без fade эффекта
    if (scrollLeft < singleSetWidth) {
      const targetScroll = scrollLeft + singleSetWidth
      panelsRef.current.scrollLeft = targetScroll
      setCurrentScrollLeft(targetScroll)
    } else if (scrollLeft > singleSetWidth * 2) {
      const targetScroll = scrollLeft - singleSetWidth
      panelsRef.current.scrollLeft = targetScroll
      setCurrentScrollLeft(targetScroll)
    }
  }, [cards.length])

  // Инициализация с fade in анимацией
  useEffect(() => {
    if (!containerRef.current || !panelsRef.current) return

    // Немедленно центрируем карточки при монтировании только если пользователь не навигаровал
    // и только при первом рендере
    if (!hasNavigated && panelsRef.current.scrollLeft === 0) {
      centerFirstCard()
    }

    // Fade in анимация для карточек при первом рендере
    const cardElements = cardsRef.current.filter(Boolean)
    cardElements.forEach((card, index) => {
      if (card) {
        card.style.opacity = '0'
        card.style.transition = 'opacity 0.5s ease-in'
        
        setTimeout(() => {
          if (card) {
            card.style.opacity = ''
          }
        }, index * 100) // Stagger эффект - каждая карточка появляется с задержкой
      }
    })

    // Простая логика для определения видимости секции
    const handleScroll = () => {
      const rect = containerRef.current?.getBoundingClientRect()
      if (rect) {
        const isVisible = rect.top < window.innerHeight * 0.8 && rect.bottom > window.innerHeight * 0.2
        setIsInView(isVisible)
      }
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [centerFirstCard])



  // Простой tooltip без анимации
  useEffect(() => {
    // Tooltip показывается/скрывается мгновенно без анимации
  }, [hoveredCard])

  // Объединенные обработчики событий для оптимизации
  useEffect(() => {
    const handleResize = () => {
      // Не центрируем при ресайзе если пользователь навигаровал
      if (!hasNavigated && panelsRef.current?.scrollLeft === 0) {
        centerFirstCard()
      }
    }
    const handleWheel = () => setHoveredCard(null)

    // Дополнительное центрирование после рендера только если пользователь не навигаровал
    const timer = setTimeout(() => {
      if (!hasNavigated && panelsRef.current?.scrollLeft === 0) {
        centerFirstCard()
      }
    }, 100)

    window.addEventListener('resize', handleResize)
    window.addEventListener('wheel', handleWheel)
    
    return () => {
      clearTimeout(timer)
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('wheel', handleWheel)
    }
  }, [centerFirstCard, hasNavigated])

  // Оптимизированная функция для вычисления стилей карточки
  const getCardStyles = useCallback((index: number) => {
    const cardWidth = 499
    const gap = 16
    const totalCardWidth = cardWidth + gap
    
    const cardPixelPosition = index * totalCardWidth - currentScrollLeft
    const containerCenter = (containerRef.current?.clientWidth || 0) / 2
    const cardCenter = cardPixelPosition + (cardWidth / 2)
    const distanceFromCenter = Math.abs(cardCenter - containerCenter)
    const normalizedDistance = distanceFromCenter / totalCardWidth
    
    // Фиксированные размеры без анимации
    const baseSize = 499 // Базовый размер центральной карточки
    const isMobile = window.innerWidth <= 768
    
    if (isMobile) {
      return { cardSize: baseSize, cardOpacity: 1, isCenter: true, leftFade: 0, rightFade: 0 }
    }
    
    // Логика с плавным изменением размера
    let cardSize = baseSize
    
    // Вычисляем позицию карточки относительно контейнера
    const containerWidth = containerRef.current?.clientWidth || 0
    const cardLeft = cardPixelPosition
    const cardRight = cardPixelPosition + cardWidth
    
    // Вычисляем затухание краев
    let leftFade = 0
    let rightFade = 0
    
    // Если карточка частично выходит за левый край
    if (cardLeft < 0) {
      const overlap = Math.abs(cardLeft)
      leftFade = Math.min(1, overlap / (cardWidth * 0.15)) // Затухание на 15% карточки
    }
    
    // Если карточка частично выходит за правый край
    if (cardRight > containerWidth) {
      const overlap = cardRight - containerWidth
      rightFade = Math.min(1, overlap / (cardWidth * 0.15)) // Затухание на 15% карточки
    }
    
    // Размер карточки
    if (normalizedDistance < 0.4) {
      // Центральная карточка
      cardSize = 499
    } else if (normalizedDistance < 1.0) {
      // Ближние карточки
      cardSize = 420
    } else if (normalizedDistance < 1.5) {
      // Средние карточки
      cardSize = 400
    } else if (normalizedDistance < 2.0) {
      // Дальние карточки
      cardSize = 380
    } else {
      // Краевые карточки
      cardSize = 360
    }
    
    const isCenter = normalizedDistance < 0.4 // Зона центра
    
    return { cardSize, cardOpacity: 1, isCenter, leftFade, rightFade }
  }, [currentScrollLeft])

  // Оптимизированные hover эффекты
  const handleCardHover = useCallback((cardId: number, isCenter: boolean, event: React.MouseEvent) => {
    if (isCenter && window.innerWidth > 768 && !isAnimating) {
      setHoveredCard(cardId)
      
      // Вычисляем позицию tooltip'а по центру карточки
      const rect = event.currentTarget.getBoundingClientRect()
      const tooltipX = rect.left + rect.width / 2
      const tooltipY = rect.top + rect.height / 2
      
      setTooltipPosition({ x: tooltipX, y: tooltipY, showAbove: true })
    }
  }, [isAnimating])

  const handleCardClick = useCallback((index: number) => {
    if (!panelsRef.current || isAnimating) return
    
    setHasNavigated(true) // Отмечаем что пользователь навигаровал
    setIsAnimating(true)
    
    const cardWidth = 499
    const gap = 16
    const totalCardWidth = cardWidth + gap
    const containerWidth = containerRef.current?.clientWidth || 0
    const containerCenter = containerWidth / 2
    
    const targetScrollLeft = (index * totalCardWidth) - containerCenter + (cardWidth / 2)
    
    // Fade out текущих карточек
    const currentCards = cardsRef.current.filter(Boolean)
    currentCards.forEach(card => {
      if (card) {
        card.style.transition = 'opacity 0.2s ease-out'
        card.style.opacity = '0'
      }
    })
    
    // После fade out перемещаем и fade in
    setTimeout(() => {
      panelsRef.current!.scrollLeft = targetScrollLeft
      setCurrentScrollLeft(targetScrollLeft)
      
      // Fade in новых карточек
      setTimeout(() => {
        currentCards.forEach(card => {
          if (card) {
            card.style.transition = 'opacity 0.3s ease-in'
            card.style.opacity = ''
          }
        })
        setIsAnimating(false)
      }, 50)
    }, 200)
  }, [isAnimating])

  // Mobile navigation functions
  const navigateToNext = useCallback(() => {
    if (!panelsRef.current || isAnimating) return
    
    setHasNavigated(true)
    setIsAnimating(true)
    
    const cardWidth = 499
    const gap = 16
    const totalCardWidth = cardWidth + gap
    const currentScroll = panelsRef.current.scrollLeft
    const targetScroll = currentScroll + totalCardWidth
    
    // Fade out текущих карточек
    const currentCards = cardsRef.current.filter(Boolean)
    currentCards.forEach(card => {
      if (card) {
        card.style.transition = 'opacity 0.2s ease-out'
        card.style.opacity = '0'
      }
    })
    
    // После fade out перемещаем и fade in
    setTimeout(() => {
      panelsRef.current!.scrollLeft = targetScroll
      setCurrentScrollLeft(targetScroll)
      
      // Fade in новых карточек
      setTimeout(() => {
        currentCards.forEach(card => {
          if (card) {
            card.style.transition = 'opacity 0.3s ease-in'
            card.style.opacity = ''
          }
        })
        setIsAnimating(false)
      }, 50)
    }, 200)
  }, [isAnimating])

  const navigateToPrevious = useCallback(() => {
    if (!panelsRef.current || isAnimating) return
    
    setHasNavigated(true)
    setIsAnimating(true)
    
    const cardWidth = 499
    const gap = 16
    const totalCardWidth = cardWidth + gap
    const currentScroll = panelsRef.current.scrollLeft
    const targetScroll = currentScroll - totalCardWidth
    
    // Fade out текущих карточек
    const currentCards = cardsRef.current.filter(Boolean)
    currentCards.forEach(card => {
      if (card) {
        card.style.transition = 'opacity 0.2s ease-out'
        card.style.opacity = '0'
      }
    })
    
    // После fade out перемещаем и fade in
    setTimeout(() => {
      panelsRef.current!.scrollLeft = targetScroll
      setCurrentScrollLeft(targetScroll)
      
      // Fade in новых карточек
      setTimeout(() => {
        currentCards.forEach(card => {
          if (card) {
            card.style.transition = 'opacity 0.3s ease-in'
            card.style.opacity = ''
          }
        })
        setIsAnimating(false)
      }, 50)
    }, 200)
  }, [isAnimating])

  return (
    <section id="team" className="min-h-screen bg-dark-800 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img 
          src="/content/fam_house_bg.jpg" 
          alt="Family House Background" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 backdrop-blur-xl"></div>
      </div>

      {/* Flying Icons Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none hidden md:block">
        {flyingIcons.map((iconData) => (
          <motion.div
            key={iconData.id}
            data-icon-id={iconData.id}
            className="absolute text-primary-400/10 blur-[0.7px]"
            style={{
              left: `${iconData.left}%`,
              top: `${iconData.top}%`,
              fontSize: `${iconData.fontSize}rem`,
            }}
            animate={{
              y: [0, -20, 0],
              x: [0, iconData.xOffset, 0],
              rotate: [0, 360],
            }}
            transition={{
              duration: iconData.duration,
              repeat: Infinity,
              ease: "linear",
              delay: iconData.delay,
            }}
          >
            {iconData.icon}
          </motion.div>
        ))}
      </div>

      <div className="relative z-10 w-full">
        {/* Header */}
        <div className="team-header text-center py-20">
          <h2 className="team-title text-4xl md:text-5xl font-display font-bold text-white mb-8">
            Познакомьтесь с{' '}
            <span className="gradient-text">Руководством</span>
          </h2>
        </div>

        {/* Horizontal Scroll Container */}
        <div 
          ref={containerRef}
          className="max-w-6xl mx-auto px-4 h-[600px] flex items-center justify-center relative overflow-hidden"
          style={{
            transition: '0s',
            overscrollBehavior: 'none'
          }}
        >
          {/* Mobile Navigation Arrows */}
          <div className="absolute inset-x-0 top-1/2 transform -translate-y-1/2 z-20 flex justify-between items-center pointer-events-none md:hidden">
            <motion.button
              onClick={navigateToPrevious}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="w-12 h-12 bg-dark-700/80 hover:bg-dark-600/90 text-white rounded-full flex items-center justify-center shadow-lg backdrop-blur-sm pointer-events-auto transition-all duration-200 ml-2"
              disabled={isAnimating}
            >
              <ChevronLeft size={24} />
            </motion.button>
            
            <motion.button
              onClick={navigateToNext}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="w-12 h-12 bg-dark-700/80 hover:bg-dark-600/90 text-white rounded-full flex items-center justify-center shadow-lg backdrop-blur-sm pointer-events-auto transition-all duration-200 mr-2"
              disabled={isAnimating}
            >
              <ChevronRight size={24} />
            </motion.button>
          </div>

          <div
            ref={panelsRef}
            className="flex h-full items-center gap-4 overflow-x-auto"
            style={{
              scrollBehavior: 'auto',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              WebkitOverflowScrolling: 'auto',
              touchAction: window.innerWidth <= 768 ? 'none' : 'pan-x'
            }}
            onScroll={handleScroll}
          >
            {infiniteCards.map((card, index) => {
              const { cardSize, cardOpacity, isCenter, leftFade, rightFade } = getCardStyles(index)
              
              return (
                <div
                  key={`${card.id}-${index}`}
                  ref={el => cardsRef.current[index] = el}
                  className="flex-shrink-0 w-[499px] h-full flex items-center justify-center relative"
                >
                                                                         <div
                    className={`bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-2xl backdrop-blur-sm hover:border-primary-500/50 group overflow-hidden cursor-pointer transition-all duration-300 relative`}
                    style={{
                      width: `${cardSize}px`,
                      height: `${cardSize * 1.11}px`,
                      opacity: cardOpacity,
                      boxShadow: isCenter ? '0 8px 25px rgba(0, 0, 0, 0.25)' : '0 4px 12px rgba(0, 0, 0, 0.15)',
                    }}
                    onMouseEnter={(e) => handleCardHover(card.id, isCenter, e)}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={() => handleCardClick(index)}
                  >
                    {/* Left edge blur copy */}
                    {leftFade > 0 && (
                      <div 
                        className="absolute left-0 top-0 w-1/3 h-full z-10 pointer-events-none overflow-hidden"
                        style={{ 
                          filter: `blur(${leftFade * 3}px)`,
                          opacity: leftFade * 0.7,
                          background: `linear-gradient(to right, rgba(0,0,0,0.3) 0%, transparent 100%)`
                        }}
                      >
                        <div className="w-full h-full bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-2xl"></div>
                      </div>
                    )}
                    
                    {/* Right edge blur copy */}
                    {rightFade > 0 && (
                      <div 
                        className="absolute right-0 top-0 w-1/3 h-full z-10 pointer-events-none overflow-hidden"
                        style={{ 
                          filter: `blur(${rightFade * 3}px)`,
                          opacity: rightFade * 0.7,
                          background: `linear-gradient(to left, rgba(0,0,0,0.3) 0%, transparent 100%)`
                        }}
                      >
                        <div className="w-full h-full bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-2xl"></div>
                      </div>
                    )}


                                         {/* Содержимое карточки */}
                     <div className="h-full flex flex-col justify-center items-center text-center relative">
                       {/* Показываем фото для всех карточек */}
                       {card.id === 1 && (
                         <div className="absolute inset-0">
                           <img 
                             src="/content/Team/Richard.png" 
                             alt="Richard" 
                             className="w-full h-full object-cover rounded-2xl"
                           />
                           <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent rounded-2xl"></div>
                           
                           <div className="absolute bottom-6 left-6 right-6 text-center">
                             <h3 className="text-xl font-bold text-white mb-1 drop-shadow-lg">
                               Richard Hugo
                             </h3>
                             <div className="text-primary-300 text-sm font-medium drop-shadow-lg">
                               Ярослав
                             </div>
                           </div>
                         </div>
                       )}
                       
                       {card.id === 2 && (
                         <div className="absolute inset-0">
                           <img 
                             src="/content/Team/Lanirr.png" 
                             alt="Lanirr" 
                             className="w-full h-full object-cover rounded-2xl"
                           />
                           <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent rounded-2xl"></div>
                           
                           <div className="absolute bottom-6 left-6 right-6 text-center">
                             <h3 className="text-xl font-bold text-white mb-1 drop-shadow-lg">
                               Lanirr Hugo
                             </h3>
                             <div className="text-primary-300 text-sm font-medium drop-shadow-lg">
                               Демьян
                             </div>
                           </div>
                         </div>
                       )}
                       
                       {card.id === 3 && (
                         <div className="absolute inset-0">
                           <img 
                             src="/content/Team/Leeshawn.png" 
                             alt="Leeshawn" 
                             className="w-full h-full object-cover rounded-2xl"
                           />
                           <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent rounded-2xl"></div>
                           
                           <div className="absolute bottom-6 left-6 right-6 text-center">
                             <h3 className="text-xl font-bold text-white mb-1 drop-shadow-lg">
                               Leeshawn Hugo
                             </h3>
                             <div className="text-primary-300 text-sm font-medium drop-shadow-lg">
                               Данёк
                             </div>
                           </div>
                         </div>
                       )}
                       
                       {card.id === 4 && (
                         <div className="absolute inset-0">
                           <img 
                             src="/content/Team/Aleister.png" 
                             alt="Aleister" 
                             className="w-full h-full object-cover rounded-2xl"
                           />
                           <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent rounded-2xl"></div>
                           
                           <div className="absolute bottom-6 left-6 right-6 text-center">
                             <h3 className="text-xl font-bold text-white mb-1 drop-shadow-lg">
                             Aleister Hugo
                             </h3>
                             <div className="text-primary-300 text-sm font-medium drop-shadow-lg">
                               Александр
                             </div>
                           </div>
                         </div>
                       )}
                       
                       {card.id === 5 && (
                         <div className="absolute inset-0">
                           <img 
                             src="/content/Team/Tony.png" 
                             alt="Tony" 
                             className="w-full h-full object-cover rounded-2xl"
                           />
                           <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent rounded-2xl"></div>
                           
                           <div className="absolute bottom-6 left-6 right-6 text-center">
                             <h3 className="text-xl font-bold text-white mb-1 drop-shadow-lg">
                               Tony Hugo
                             </h3>
                             <div className="text-primary-300 text-sm font-medium drop-shadow-lg">
                               Вадим
                             </div>
                           </div>
                         </div>
                       )}
                       
                       {card.id === 6 && (
                         <div className="absolute inset-0">
                           <img 
                             src="/content/Team/Logan.png" 
                             alt="Logan" 
                             className="w-full h-full object-cover rounded-2xl"
                           />
                           <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent rounded-2xl"></div>
                           
                           <div className="absolute bottom-6 left-6 right-6 text-center">
                             <h3 className="text-xl font-bold text-white mb-1 drop-shadow-lg">
                               Logan Hugo
                             </h3>
                             <div className="text-primary-300 text-sm font-medium drop-shadow-lg">
                               Ильдар
                             </div>
                           </div>
                         </div>
                       )}
                       
                       {card.id === 7 && (
                         <div className="absolute inset-0">
                           <img 
                             src="/content/Team/Quincy.png" 
                             alt="Quincy" 
                             className="w-full h-full object-cover rounded-2xl"
                           />
                           <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent rounded-2xl"></div>
                           
                           <div className="absolute bottom-6 left-6 right-6 text-center">
                             <h3 className="text-xl font-bold text-white mb-1 drop-shadow-lg">
                               Quincy Hugo
                             </h3>
                             <div className="text-primary-300 text-sm font-medium drop-shadow-lg">
                               Никита
                             </div>
                           </div>
                         </div>
                       )}
                       
                       {card.id === 8 && (
                         <div className="absolute inset-0">
                           <img 
                             src="/content/Team/Federick.png" 
                             alt="Federick" 
                             className="w-full h-full object-cover rounded-2xl"
                           />
                           <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent rounded-2xl"></div>
                           
                           <div className="absolute bottom-6 left-6 right-6 text-center">
                             <h3 className="text-xl font-bold text-white mb-1 drop-shadow-lg">
                               Federick Hugo
                             </h3>
                             <div className="text-primary-300 text-sm font-medium drop-shadow-lg">
                               Федор
                             </div>
                           </div>
                         </div>
                       )}
                     </div>

                                         {/* Hover Effect Overlay */}
                     <div className="absolute inset-0 bg-gradient-to-t from-primary-600/10 to-transparent opacity-0 group-hover:opacity-100 rounded-2xl pointer-events-none"></div>
                  </div>
                </div>
              )
            })}

            
          </div>
        </div>
      </div>

             {/* Global Tooltip */}
       {hoveredCard && window.innerWidth > 768 && !isAnimating && (
        <div 
          className="team-tooltip fixed z-[9999] w-96 max-w-md pointer-events-none"
          style={{
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y}px`,
            transform: 'translateX(-50%) translateY(-50%)'
          }}
        >
                     <div 
             className="rounded-2xl p-6 shadow-2xl bg-gradient-to-br from-gray-950/95 via-gray-900/90 to-gray-950/95 backdrop-blur-md border border-gray-700/50" 
             style={{
               boxShadow: '0 25px 50px rgba(0, 0, 0, 0.7), 0 10px 20px rgba(0, 0, 0, 0.5)'
             }}
           >
            <div className="space-y-4">
              <div>
                <h4 className={`${hoveredCard === 5 ? 'text-sm' : 'text-base'} font-semibold text-primary-200 mb-2`}>
                  1. Как давно вы в семье и как попали?
                </h4>
                <p className={`${hoveredCard === 5 ? 'text-xs' : 'text-sm'} text-white leading-relaxed`}>
                  {teamAnswers[hoveredCard as keyof typeof teamAnswers]?.answer1 || "Ответ не найден"}
                </p>
              </div>

              <div>
                <h4 className={`${hoveredCard === 5 ? 'text-sm' : 'text-base'} font-semibold text-primary-200 mb-2`}>
                  2. В чем заключается Ваш вклад в семью?
                </h4>
                <p className={`${hoveredCard === 5 ? 'text-xs' : 'text-sm'} text-white leading-relaxed`}>
                  {teamAnswers[hoveredCard as keyof typeof teamAnswers]?.answer2 || "Ответ не найден"}
                </p>
              </div>

              <div>
                <h4 className={`${hoveredCard === 5 ? 'text-sm' : 'text-base'} font-semibold text-primary-200 mb-2`}>
                  3. Какие особенности отличают HUGO от других по вашему мнению?
                </h4>
                <p className={`${hoveredCard === 5 ? 'text-xs' : 'text-sm'} text-white leading-relaxed`}>
                  {teamAnswers[hoveredCard as keyof typeof teamAnswers]?.answer3 || "Ответ не найден"}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Scroll Arrow */}
      {isInView && (
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-50 hidden sm:block">
          <ScrollArrow targetId="services" offset={-70} />
        </div>
      )}
    </section>
  )
}

export default Team 